module.exports = __webpack_public_path__ + "img/2.20daac4b.svg";